import { useEffect, useState } from "react";
import chatIcon from "../../assets/chat.svg";
import phoneIcon from "../../assets/phone-icon.svg";
import eyeIcon from "../../assets/eye.svg";
import supportIcon from "../../assets/support.svg";
import penIcon from "../../assets/pen-design.svg";
import unlimiterIcon from "../../assets/unlimiter.svg";
import iphone from "../../assets/iphone.png";
import bg from "../../assets/screens/2.png";
import "./style.css";
import { useLocation } from "react-router-dom";

const Features = () => {
	const location = useLocation();
	const [data, setData] = useState([
		{
			icon: chatIcon,
			label: "Personalized Touch",
			description: "Print the deceased’s name on prayers and water bottles.",
		},
		{
			icon: phoneIcon,
			label: "Venue Support",
			description: "Chairs, valet parking, and seamless ceremony arrangements.",
		},
		{
			icon: eyeIcon,
			label: "Family Comfort.",
			description:
				"Organizing every detail of the funeral with ease and professionalism.",
		},
		{
			icon: supportIcon,
			label: "24/7 Support",
			description:
				"Our team is always available to assist you anytime during the funeral organization process.",
		},
		{
			icon: penIcon,
			label: "Spiritual Distributions.",
			description: "Qur’ans, Zamzam water, and prayers for the deceased.",
		},
		{
			icon: unlimiterIcon,
			label: "Full Hospitality",
			description: "Tea, coffee, and all necessary refreshments for guests.",
		},
	]);

	useEffect(() => {
		if (location.state?.scrollTo) {
			const element = document.getElementById(location.state.scrollTo);
			if (element) {
				element.scrollIntoView({ behavior: "smooth" });
			}
		}
	}, [location]);

	return (
		<div
			className="features"
			id="Features"
			data-aos="fade-up"
			data-aos-duration="1200">
			<div className="container">
				<p className="title">App features</p>
				<p className="description">
					Organize Funeral Ceremonies with Ease and Comfort.
				</p>
				<div className="features-data">
					<div className="row position-relative">
						<div className="col-lg-12 col-md-6 order1">
							{data?.length >= 0 && (
								<div className="feature-card w-100 mb-5 text-center">
									<img src={data[0].icon} alt="icon" />
									<div>
										<p className="title">{data[0].label}</p>
										<p className="description">{data[0].description}</p>
									</div>
								</div>
							)}
						</div>
						<div className="col-lg-4 col-md-6 order2">
							<div className="h-100 py-5 px-3 d-flex flex-column justify-content-between align-items-end">
								{data?.length >= 5 && (
									<div className="feature-card text-end">
										<img src={data[5].icon} alt="icon" />
										<div>
											<p className="title text-end">{data[5].label}</p>
											<p className="description text-end">
												{data[5].description}
											</p>
										</div>
									</div>
								)}
								{data?.length >= 4 && (
									<div className="feature-card text-end">
										<img src={data[4].icon} alt="icon" />
										<div>
											<p className="title text-end">{data[4].label}</p>
											<p className="description text-end">
												{data[4].description}
											</p>
										</div>
									</div>
								)}
							</div>
						</div>
						<div className="col-lg-4 col-md-6 order3">
							<div className="iphone-card">
								<img src={iphone} className="iphone" alt="iphone" />
								<img src={bg} className="bg" alt="bg" />
							</div>
						</div>
						<div className="col-lg-4 col-md-6 order4">
							<div className="h-100 py-5 px-3 d-flex flex-column justify-content-between align-items-start">
								{data?.length >= 1 && (
									<div className="feature-card text-start">
										<img src={data[1].icon} alt="icon" />
										<div>
											<p className="title text-start">{data[1].label}</p>
											<p className="description text-start">
												{data[1].description}
											</p>
										</div>
									</div>
								)}
								{data?.length >= 2 && (
									<div className="feature-card text-start">
										<img src={data[2].icon} alt="icon" />
										<div>
											<p className="title text-start">{data[2].label}</p>
											<p className="description text-start">
												{data[2].description}
											</p>
										</div>
									</div>
								)}
							</div>
						</div>
						<div className="col-lg-12 col-md-6  order5">
							{data?.length >= 3 && (
								<div className="feature-card w-100 mt-5 text-center">
									<img src={data[3].icon} alt="icon" />
									<div>
										<p className="title">{data[3].label}</p>
										<p className="description">{data[3].description}</p>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Features;
